import { useContext } from 'react';
import { EditorDataContext } from '../context/editor-data-context';

export const useEditorData = () => {
  const context = useContext(EditorDataContext);
  if (!context) {
    throw new Error('useEditorData debe usarse dentro de EditorDataProvider');
  }
  return context;
};
